import React from 'react';
import { useAppSelector } from '../../../store/store';
import { getBrandCampaigns, getDefaultCampaigns } from '../../../store/selector/campaign.selector';
import SwitchCampaignPlan from './SwitchCampaignPlan';
import SwitchNewCampaign from './SwitchNewCampaign';

interface IProps {
    setIsSwitching: React.Dispatch<React.SetStateAction<boolean>>;
}

const SwitchPlan = ({ setIsSwitching }: IProps) => {
    const defaultCampaigns = useAppSelector(getDefaultCampaigns);
    const brandCampaigns = useAppSelector(getBrandCampaigns);

    return (
        <div className="tw-w-full">
            {brandCampaigns.length > 0 && (
                <div className="tw-w-full">
                    <div className="tw-flex tw-items-center tw-gap-x-2 tw-mb-4">
                        <i
                            className="ph-bold ph-caret-left tw-rounded-full tw-bg-purple-50 tw-text-purple-500 tw-p-2 tw-cursor-pointer"
                            onClick={() => setIsSwitching(false)}
                        ></i>
                        <div className="tw-font-medium">Your Plans</div>
                    </div>
                    <div className="tw-flex tw-flex-wrap tw-gap-4">
                        <SwitchNewCampaign setIsSwitching={setIsSwitching} />
                        {brandCampaigns.map((campaign) => (
                            <SwitchCampaignPlan
                                campaign={campaign}
                                setIsSwitching={setIsSwitching}
                            />
                        ))}
                    </div>
                </div>
            )}

            {defaultCampaigns.length > 0 && (
                <div className="tw-w-full tw-mt-20">
                    <div className="tw-font-medium tw-mb-4">Suggested Plans For You</div>
                    <div className="tw-flex tw-flex-wrap tw-gap-4">
                        {defaultCampaigns.map((campaign) => (
                            <SwitchCampaignPlan
                                campaign={campaign}
                                setIsSwitching={setIsSwitching}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SwitchPlan;
